import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactBootstrap from 'react-bootstrap';

class DeleteJobDefinition extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.hideHandler = this.hideHandler.bind(this);
        this.showHandler = this.showHandler.bind(this);
        this.deleteJobDefinitionHandler = this.deleteJobDefinitionHandler.bind(this);
        this.enteredHandler = this.enteredHandler.bind(this);

        this.state = {
            show: false
        };
    }

    hideHandler() {
        this.setState({ show: false });
        this.setState({ job_reference: null });
    }
    showHandler() {
        this.setState({ show: true });
    }
    enteredHandler() {
        let node = ReactDOM.findDOMNode(this.cancelRef);
        if (node && node.focus instanceof Function) {
            node.focus();
        }
    }
    deleteJobDefinitionHandler() {
        this.props.onDelete();
        this.hideHandler();
    }
    render() {
        return (
            <div className="modal-container">
                <ReactBootstrap.Button
                    variant="danger"
                    onClick={this.showHandler}
                >
                    Delete Job
                </ReactBootstrap.Button>

                <ReactBootstrap.Modal
                    size="sm"
                    show={this.state.show}
                    onHide={this.hideHandler}
                    onEntered={this.enteredHandler}
                    aria-labelledby="contained-modal-title"
                    onKeyPress={event => {
                        if (event.key === "Enter") {
                            this.hideHandler();
                        }
                    }}
                >
                    <ReactBootstrap.Modal.Header closeButton>
                        <ReactBootstrap.Modal.Title id="contained-modal-title">
                            Delete {this.props.jobRef}<br />From {this.props.extractionName}
                        </ReactBootstrap.Modal.Title>
                    </ReactBootstrap.Modal.Header>
                    <ReactBootstrap.Modal.Footer>
                        <ReactBootstrap.Button
                            variant="danger"
                            onClick={this.deleteJobDefinitionHandler}
                        >
                            Delete
              </ReactBootstrap.Button>
                        <ReactBootstrap.Button
                            variant="secondary"
                            onClick={this.hideHandler}
                            ref={input => (this.cancelRef = input)}
                        >
                            Cancel
              </ReactBootstrap.Button>
                    </ReactBootstrap.Modal.Footer>
                </ReactBootstrap.Modal>
            </div>
        );
    }
}

export default DeleteJobDefinition;